import useScreenSize from '../../hooks/useScreenSize'
import Sheet from '../Sheet/Sheet'
import Drawer from '../Drawer/Drawer'
import type { OverlayProps } from './overlay.types'

// Side-sheet on desktop, bottom drawer on mobile.
function ResponsiveSheet(props: OverlayProps) {
  const isDesktop = useScreenSize('sm')
  return isDesktop ? <Sheet {...props} /> : <Drawer {...props} />
}

export default ResponsiveSheet
